import { getTagItem } from 'backend/data-methods.jsw';
import wixAnimations from 'wix-animations';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(() => {
    initPage();
});

async function initPage() {

    // change to the first state of the tags
    let firstBtnLabel = $w('#buttonFirst').label;
    let item = await getTagItem(firstBtnLabel);
    changeTag(item);

    // call functions
    cards();
    filterTags(); // filter the tag section by the buttons

    // //click on item
    $w('#blogItem').onClick((event) => {
        const data = $w("#blogRepeater").data;
        let clickedItemData = data.find(item => item._id === event.context.itemId);
        wixLocation.to(wixLocation.baseUrl + clickedItemData.blogRef.postPageUrl);
    });
}

function cards() {
    $w('#cardsWrapper').children.forEach((card, index) => {
        card.onMouseIn(() => {
            showRelevantCard(index)
        })
    });
}

async function showRelevantCard(cardIndex) {
    const cards = $w('#cardsWrapper').children;
    const cardGap = 100 //px

    getWindowWidth().then(winWidth => {
        cards.forEach((card, index) => {
            let space = index === cards.length ? cardGap * cards.length : cards.length * cardGap;
            if (index > cardIndex) {
                wixAnimations.timeline()
                    .add(card, { x: -winWidth + space, duration: 500 })
                    .play();
            } else {
                wixAnimations.timeline()
                    .add(card, { x: 0, duration: 500 })
                    .play();
            }
        });
    })

}

async function getWindowWidth() {
    return wixWindow.getBoundingRect()
        .then((windowSizeInfo) => {
            return windowSizeInfo.document.width;
        });
}

export function button22_click(event) {
    $w('#box19').expand();
    $w('#box18').collapse();
    $w('#box94').collapse();
    $w('#box96').collapse();
    $w('#box98').collapse();
}

export function button23_click_1(event) {
    $w('#box94').expand();
    $w('#box18').collapse();
    $w('#box19').collapse();
    $w('#box96').collapse();
    $w('#box98').collapse();
}

export function button24_click_1(event) {
    $w('#box98').expand();
    $w('#box18').collapse();
    $w('#box19').collapse();
    $w('#box94').collapse();
    $w('#box96').collapse();
}

export function button21_click_1(event) {
    $w('#box18').expand();
    $w('#box19').collapse();
    $w('#box94').collapse();
    $w('#box96').collapse();
    $w('#box98').collapse();
}

export function button54_click(event) {
    $w('#box96').expand();
    $w('#box19').collapse();
    $w('#box94').collapse();
    $w('#box18').collapse();
    $w('#box98').collapse();
}

// function for filtering the tags by the btns
function filterTags() {
    const g_Orange = '#F97F41';
    const g_White = '#FFFFFF';

    //Design for Tag Boxes on Select
    let tagsBoxes = $w('#tagsContainer').children;
    let lastSelection = $w('#buttonFirst'); // select/deselect tag

    tagsBoxes.forEach(tagBox => {
        let tagBtn = tagBox.children.find(child => child.id.includes('button'));

        tagBox.onClick(async () => {
            lastSelection.style.backgroundColor = g_White; //change last btn style
            tagBtn.style.backgroundColor = g_Orange; // change selcted btn style
            lastSelection = tagBtn; // save the last selected btn
            
            //filter the tags
            let item = await getTagItem(tagBtn.label);
            changeTag(item);
        })
    })
}

function changeTag(item) {
    $w('#tagTitleText').text = item.title;
    $w('#tagContentText').text = item.content;
    $w('#tagImage').src = item.image;
    $w('#tagMoreBtn').link = item.learnMoreLink;
}